import React from "react";
import CardSlide from "../Slider/card_slide";

export const SlideData = [
  {
    id: 1,
    name: "Tie-dye Legging",
    cate: "39,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FTie-dye%20Legging%20(1).jpg?alt=media&token=28a7e2b4-5ed1-4aa9-be55-f316db5b96fe",
  },
  {
    id: 2,
    name: "Movement Leggings",
    cate: "39,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FMovement%20Legging%20(1).jpg?alt=media&token=b4160f6e-34dd-4f3c-9428-2feb6211e309",
  },
  {
    id: 3,
    name: "Mermaid Leggings",
    cate: "39,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FMermaid%20Legging%20(1).jpg?alt=media&token=ddabc8af-e1c2-4303-95d6-64adb1e942b9",
  },
  {
    id: 4,
    name: "Edge Leggings",
    cate: "34,000 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FEdge%20Legging%20(1).jpg?alt=media&token=1f4adbd5-f8cc-4256-9148-c9475e1583bc",
  },
  {
    id: 5,
    name: "Bliss legging",
    cate: "39,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FBliss%20Legging%20(1).jpg?alt=media&token=6585a074-40c3-4ec7-a534-15fb59b32196",
  },
  {
    id: 6,
    name: "Aura Leggings",
    cate: "39,500 MMK",
    img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FAura%20Legging%20(1).jpg?alt=media&token=50cb4280-21ef-4c67-83d9-30efbbdaccb1",
  },
];
const Legging = ({title,subTitle}) => {
  return (
    <div>
      <div className="text-center mb-2 mt-10">
                 <h2 className="uppercase text-[13px] ">{title}</h2>
                 <h1 className="uppercase text-[22px]">{subTitle}</h1>
            </div>
      <CardSlide SlideData={SlideData} /> 
           <div className="text-center mt-8"><button className="bg-primary text-white  text-sm uppercase px-6 py-2 ">Shop now</button></div>
           <hr className="mt-10" />
    </div>
  );
};

export default Legging;
